// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/design-tokens/dist/responsive-web/usb-light/usb-light.custom-properties.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/themes/dist/library/styles/reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/themes/dist/library/styles/fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/react-loading-spinner/dist/library/styles/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-overlay {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    opacity: 0.8;
    background-color: rgba(0, 0, 0, 0.5);
}

.usb-loading-spinner-container .usb-loading-spinner_path {
    stroke: #0C2074;
    stroke: var(--usb-color-primary, #0C2074);
}`, "",{"version":3,"sources":["webpack://./src/auth/LoadingSpinner.css"],"names":[],"mappings":"AAKA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,MAAM;IACN,OAAO;IACP,OAAO;IACP,SAAS;IACT,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,eAAyC;IAAzC,yCAAyC;AAC7C","sourcesContent":["@import url('@usb-shield/design-tokens/dist/responsive-web/usb-light/usb-light.custom-properties.css');\n@import url('@usb-shield/themes/dist/library/styles/reset.css');\n@import url('@usb-shield/themes/dist/library/styles/fonts.css');\n@import url('@usb-shield/react-loading-spinner/dist/library/styles/index.css');\n\n.spinner-overlay {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    top: 0;\n    left: 0;\n    right:0;\n    bottom: 0;\n    opacity: 0.8;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.usb-loading-spinner-container .usb-loading-spinner_path {\n    stroke: var(--usb-color-primary, #0C2074);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
